const attendance_records = {
  permissionSource: 'api::attendance-record.attendance-record',
  creationTitle: 'Create Attendance Record',
  creationEndPoint: '/attendance-records?populate=*',
  detailTitle: 'Attendance Record',
  detailEndPoint:
    '/attendance-records/:id?populate[0]=staff&populate[1]=leave.approved_by&populate[2]=leave.proof_document',
  detail: [
    {
      label: 'Attendance Log',
      value: 'attendance_log',
      tag: 'json-editor',
      required: true,
    },
    {
      label: 'Staff',
      value: 'staff',
      tag: 'single-select',
      dataSourceUrl: '/staffs',
      dataLabel: 'name',
      required: true,
    },
    {
      isLayout: true,
      layoutPattern: '1-1-1',
      children: [
        {
          label: 'Create Date / Time',
          value: 'custom_created_at',
          tag: 'static-text',
        },
        {
          label: 'Publish Date / Time',
          value: 'publishedAt',
          tag: 'static-text',
        },
        {
          label: 'Update Date / Time',
          value: 'custom_updated_at',
          tag: 'static-text',
        },
      ],
    },
  ],
}
export default attendance_records
